/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClientNoteResponse,
  ProblemDetails,
  UpdateClientNoteRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    ClientNoteResponseFromJSON,
    ClientNoteResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateClientNoteRequestFromJSON,
    UpdateClientNoteRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface GetClientNoteRequest {
    clientId: string;
}

export interface UpdateClientNoteOperationRequest {
    clientId: string;
    updateClientNoteRequest: UpdateClientNoteRequest;
}

/**
 * ClientNoteApi - interface
 * 
 * @export
 * @interface ClientNoteApiInterface
 */
export interface ClientNoteApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientNoteApiInterface
     */
    getClientNoteRaw(requestParameters: GetClientNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientNoteResponse>>;

    /**
     */
    getClientNote(requestParameters: GetClientNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientNoteResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {UpdateClientNoteRequest} updateClientNoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientNoteApiInterface
     */
    updateClientNoteRaw(requestParameters: UpdateClientNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientNoteResponse>>;

    /**
     */
    updateClientNote(requestParameters: UpdateClientNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientNoteResponse>;

}

/**
 * 
 */
export class ClientNoteApi extends runtime.BaseAPI implements ClientNoteApiInterface {

    /**
     */
    async getClientNoteRaw(requestParameters: GetClientNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientNoteResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClientNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/note`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientNoteResponseFromJSON(jsonValue));
    }

    /**
     */
    async getClientNote(requestParameters: GetClientNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientNoteResponse> {
        const response = await this.getClientNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateClientNoteRaw(requestParameters: UpdateClientNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientNoteResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateClientNote().'
            );
        }

        if (requestParameters['updateClientNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClientNoteRequest',
                'Required parameter "updateClientNoteRequest" was null or undefined when calling updateClientNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/note`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClientNoteRequestToJSON(requestParameters['updateClientNoteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientNoteResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateClientNote(requestParameters: UpdateClientNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientNoteResponse> {
        const response = await this.updateClientNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
